// apps/web/hooks/maincontent/useLocalStorageInitialization.ts
import { useEffect, useState } from 'react';

import { FormContents } from '../../types/page';

interface UseLocalStorageInitializationProps {
  isSignedIn: boolean;
  isAuthLoading: boolean;
  contentProperties: Record<string, string>;
  formContents: FormContents;
  isStreamDone: boolean;
  removeItemByKey: (key: string) => void;
  setItemByKey: (key: string, value: string) => void;
}

export function useLocalStorageInitialization({
  isSignedIn,
  isAuthLoading,
  contentProperties,
  formContents,
  isStreamDone,
  removeItemByKey,
  setItemByKey,
}: UseLocalStorageInitializationProps): {
  isInitializedFromLocalStorage: boolean;
} {
  const [isInitializedFromLocalStorage, setIsInitializedFromLocalStorage] =
    useState(false);

  useEffect(() => {
    if (!isSignedIn && !isAuthLoading) {
      contentProperties &&
        Object.keys(contentProperties).forEach(function (key) {
          removeItemByKey(contentProperties[key]);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn]);

  useEffect(() => {
    if (!isInitializedFromLocalStorage && typeof window !== 'undefined') {
      setIsInitializedFromLocalStorage(true);
    }
  }, [isInitializedFromLocalStorage]);

  // Save to localStorage
  useEffect(() => {
    if (isInitializedFromLocalStorage) {
      for (const property in contentProperties) {
        setItemByKey(contentProperties[property], formContents[property]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formContents, isStreamDone, isInitializedFromLocalStorage]);

  return { isInitializedFromLocalStorage };
}
